import React from 'react'
import { Modal, ModalBody } from "reactstrap"


const RewardDeleteConfirmModal = ({ visible, onConfirmDelete, onSubmitData }) => {

  return (
    <Modal isOpen={visible} toggle={onConfirmDelete} size='lg'>
        <ModalBody>
        <div className='signout-confirm-wrapper m-auto'>
            <h4 className='text-primary-800 fw-regular ft-default mb-4'>Delete Reward</h4>
            <h5 className='text-gray-600 fw-regular ft-default mb-5'>Are you sure you want to delete this reward?</h5>
            <div className='button-box d-md-flex'>
                <div className='btn btn-secondary' onClick={onConfirmDelete}>Cancel</div>
                <div className='btn btn-primary' onClick={onSubmitData}>Yes</div>
            </div>
        </div>
        </ModalBody>
    </Modal>
  )
}


export default RewardDeleteConfirmModal